<div class="tickets-overview-request">
  <div class="tickets-header">
    @let showContractPicker =
      (onlyExpiredContractsAndActiveMembership$ | async) === false &&
      (numberOfContracts | async) > 0;
    <div class="tickets-header__title" [class.tickets-header__title--single]="hasSingleContract()">
      <rs-web-cards-container-header
        class="tickets-header__headline"
        [icon]="immomioIconName.Ticket"
        [title]="'ticket_active_concerns_l'"
        [buttonText]="'ticket_request.create_new_b'"
        (tapped)="createTicket()"
      ></rs-web-cards-container-header>
      @if (showContractPicker && hasSingleContract()) {
        <rs-web-contract-picker
          [contracts]="contractOptions()"
          [unreadContractIds]="unreadContractIds()"
          [contractId]="selectedContractId()"
          (contractIdChange)="selectContract($event)"
        ></rs-web-contract-picker>
      }
    </div>
    <div class="tickets-header__actions">
      @if (showContractPicker && !hasSingleContract()) {
        <rs-web-contract-picker
          class="tickets-header__contract-select"
          [contracts]="contractOptions()"
          [unreadContractIds]="unreadContractIds()"
          [contractId]="selectedContractId()"
          (contractIdChange)="selectContract($event)"
        ></rs-web-contract-picker>
      }
      @if (
        (ticketingVersion$ | async) === ticketingVersion.METADATA &&
        (requestTickets$ | async)?.length > 0
      ) {
        <rs-web-sorting-menu [type]="sortTypes.TICKETS"></rs-web-sorting-menu>
      }
    </div>
  </div>

  <div class="mb-4">
    <rs-web-tickets
      [tickets]="requestTickets$ | async"
      [ticketsActionState]="requestTicketsActionState$ | async"
      [hasNextPage]="hasNextPage$ | async"
      [hasActiveContracts]="selectedContractIsActive"
      [createButtonText]="'ticket_request.create_new_b'"
      [txtNoTickets]="'active_request.no_data'"
      [isArchiving]="isArchiving$ | async"
      (openTicket)="openTicket.emit($event)"
      (loadMoreTickets)="loadMoreRequestTickets()"
      (createTicket)="createTicket()"
      (archiveTicket)="onArchiveTicket($event)"
    >
      @if (
        (ticketingVersion$ | async) === ticketingVersion.METADATA &&
        (ticketSettings$ | async)?.concernTicketingType === ticketingType.EXTERNAL
      ) {
        <rs-web-ticket-information-notice new-ticket-info></rs-web-ticket-information-notice>
      }
    </rs-web-tickets>
  </div>
</div>
